export default __webpack_public_path__ + "static/media/interest calculator .dbde5356.webp";